'use strict'

// 将EPOC以来的毫秒数格式化为两种指定样式，'2018年08月21日' 或 '08月21日'
export function formatDate (val, format) {
  if (!val) return ''
  let date = new Date(parseInt(val))
  let month = date.getMonth() + 1
  let day = date.getDate()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  if (format === 'month') {
    return month + '月' + day + '日'
  } else if (format === 'year') {
    var year = date.getFullYear()
    return year + '年' + month + '月' + day + '日'
  }
  return '未定义format'
}

// 通过字符串截取方式来格式化经纬度{ "factor": 4, "unit": 41, "value": 1162317 } => 116.2317
export function formatLocation (objData) {
  if (!objData) return ''
  const objDataStr = String(objData.value)
  if (!objData.factor) return objDataStr
  const pointPosition = objDataStr.length - objData.factor
  return objDataStr.substr(0, pointPosition) + '.' + objDataStr.substr(pointPosition)
}



// WEBPACK FOOTER //
// ./src/filters/index.js